<script>
import Vue from "vue";
import Swal from "sweetalert2";
import simplebar from "simplebar-vue";
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import DatePicker from "vue2-datepicker";
//import attchart from "./attchart";
//import DateRangePicker from 'vue2-daterange-picker'
import { OveviewChart} from "./data";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
/**
 * Wallets component
 */

export default {
  page: {
    title: "Attendance",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    simplebar,
    DatePicker,
    //DateRangePicker,
    //attchart
  },
  data() {
    return {
      OveviewChart: OveviewChart,
      attendanceData: [],
      filterValue: "",
      filterLeaveApplnValue: "",
      attSummaryData: {
        present: 0,
        absent: 0,
        late: 0,
      },
      dateRange: {
      },
      calendarMonths: {
        startMonth: 1,
        endMonth: 12
      },
      manageLeaves: false,
      leaveBalance: [],
      leaveActionModal: false,
      leaveRejectModal: false,
      attLoader: false,
      leaveApplnLoader: false,
      preDefinedRange: {},
      newLeaveName: '',
      editLeaveName: false,
      leaveData: [
      ],
      leaveDataFilters: {
        pending: false,
        approved: false,
        rejected: false
      },
      leavePolicy: {
        privgLeave: {
          name: 'Privilege Leave',
          isEnabled: false,
          type: 1,
          noOfDays: '',
          isCarriedForward: false,
          minmEligiblePeriod: ''
        },
        casualLeave: {
          name: 'Casual Leave',
          isEnabled: false,
          type: 2,
          noOfDays: '',
          isCarriedForward: false,
          isAnyMonthlyMax: false,
          monthlyMax: ''
        },
        sickLeave: {
          name: 'Sick Leave',
          isEnabled: false,
          type: 3,
          noOfDays: '',
          isCarriedForward: false,
          isAnyMonthlyMax: false,
          monthlyMax: ''
        },
        maternityLeave: {
          name: 'Maternity Leave',
          isEnabled: false,
          type: 4,
          noOfDays: '',
        },
        marriageLeave: {
          name: 'Marriage Leave',
          isEnabled: false,
          type: 5,
          noOfDays: '',
        },
        paternityLeave: {
          name: 'Paternity Leave',
          isEnabled: false,
          type: 6,
          noOfDays: '',
        },
        bereavLeave: {
          name: 'Bereavement Leave',
          isEnabled: false,
          type: 7,
          noOfDays: '',
        },
        compOffLeave: {
          name: 'Compensatory Off (comp-off)',
          isEnabled: false,
          type: 8,
        },
        lwpLeave: {
          name: 'Leave Without Pay (LWP)',
          isEnabled: false,
          type: 9,
        },
        customLeaves : [
        ]
      },
      holidays: [
      ],
      rejectLeaveData: {
        empId: '',
        leaveId: '',
        comments: '',
      },
      approveLeaveData: {
      },
      approveLeaveError: false,
      holidayYear: null,
      calMonths: ["January", "February", "March","April", "May","June", "July","August", "September","October", "November", "December"],
      monthDays: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      attDate: "",
      selectedDate: "2022-03-21",
      loginData: {},
      title: "Attendance and Leave",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterLeave: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      headVariant: "light",
      mixedChart: {
        series: [{
            name: 'Late',
            type: 'column',
            data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30, 23, 11, 22, 27, 23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30, 23, 11, 22, 27, 23]
        },{
            name: 'Absent',
            type: 'area',
            data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43, 44, 55, 41, 67, 44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43, 44, 55, 41, 67, 23]
        }, {
            name: 'Present',
            type: 'line',
            data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39, 30, 25, 36, 30, 30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39, 30, 25, 36, 30, 23]
        },
        {
            name: 'On Leave',
            type: 'column',
            data: [2, 3, 5, 6, 0, 1, 10, 2, 10, 0, 0, 0, 25, 36, 30, 30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39, 30, 25, 36, 30, 23]
        }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false
            },
            zooom: {
              enabled: false
            }
        },
        stroke: {
            width: [0, 2, 4],
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '50%'
            }
        },
        colors: ['#f46a6a', '#556ee6', '#34c38f', '#f1b44c'],
        fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['01/01/2003', '01/02/2003', '01/03/2003', '01/04/2003', '01/05/2003', '01/06/2003', '01/07/2003', '01/08/2003', '01/09/2003', '01/10/2003', '01/11/2003' , '01/12/2003', '01/13/2003', '01/14/2003', '01/15/2003', '01/16/2003', '01/17/2003', '01/18/2003', '01/19/2003', '01/20/2003', '01/21/2003', '01/22/2003', '01/23/2003', '01/24/2003', '01/25/2003', '01/26/2003', '01/27/2003', '01/28/2003', '01/29/2003', '01/30/2003', '01/31/2003'],
        markers: {
            size: 0
        },
        xaxis: {
            type: ''
        },
        yaxis: {
            title: {
                text: 'Employees',
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (y) {
                    if (typeof y !== "undefined") {
                        return y.toFixed(0) + " Employees";
                    }
                    return y;

                }
            }
        },
        grid: {
            borderColor: '#f1f1f1'
        }
    }
      },
      /*fields: [
        {
          key: "name",
          label: "menuitems.attendance.name",
          sortable: true
        },
        {
          key: "clockIn",
          label: "Clock In",
          sortable: true
        },
        {
          key: "clockOut",
          label: "Clock Out",
          sortable: true
        },
        {
          key: "remarks",
          label: "Remarks",
          sortable: true
        },
        {
          key: "view",
          label: "Action"
        },
      ],*/
      leaveFields: [
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "fromDate",
          label: "From",
          sortable: true
        },
        {
          key: "toDate",
          label: "To",
          sortable: true
        },
        {
          key: "leaveReason",
          label: "Reason",
          sortable: true
        },
        {
          key: "action",
          label: "Action"
        },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    fields() {
      // Accessing this.$i18n.locale in this computed prop tells Vue that
      // this computed prop should update whenever this.$i18n.locale
      // changes it value, even though we don't use the value.
      const lang = this.$i18n.locale
      // We add the following just so that minification optimizers
      // do not remove the above statement because the return value isn't used.
      if (!lang) { return [] }
      // Return the array of translated values
      return [
        { key: 'name', label: this.getColLabel('menuitems.attendance.name') },
        { key: 'clockIn', label: this.getColLabel('menuitems.attendance.clockIn') },
        { key: 'clockOut', label: this.getColLabel('menuitems.attendance.clockOut') },
        { key: 'remarks', label: this.getColLabel('menuitems.attendance.remarks') },
        { key: 'view', label: this.getColLabel('menuitems.attendance.action') },
          // ...
        ]
    },
    rows() {
      return this.attendanceData.length;
    },
     searchLeaveApplnEvents: function(){
      var result = this.leaveData;
      if (!this.filterLeaveApplnValue && this.leaveDataFilters.pending == false && this.leaveDataFilters.approved == false && this.leaveDataFilters.rejected == false)
        return result;
      
      const pending = this.leaveDataFilters.pending;
      const approved = this.leaveDataFilters.approved;
      const rejected = this.leaveDataFilters.rejected;

      const filterValue = this.filterLeaveApplnValue.toLowerCase();

      const filter = event => {
          if(pending || approved || rejected) {
            let val1 = event.name.toLowerCase().includes(filterValue) ||
                  event.email.toLowerCase().includes(filterValue);

            if(pending && !approved && !rejected) {
              return val1 && (event.status == 0);
            }
            else if(approved && !pending && !rejected) {
              return val1 && (event.status == 1);
            }
            else if(rejected && !pending && !approved) {
              return val1 && (event.status == 2);
            }
            else if(pending && approved && !rejected) {
              return val1 && (event.status == 0 || event.status == 1);
            }
            else if(pending && rejected && !approved) {
              return val1 && (event.status == 0 ||event.status == 2);
            }
            else if(approved && rejected && !pending) {
              return val1 && (event.status == 1 || event.status == 2);
            }
            return val1;
          }
          return event.name.toLowerCase().includes(filterValue) ||
                  event.email.toLowerCase().includes(filterValue);
      }
       //this.timeMinutes[this.imgs.indexOf(event)];
      return result.filter(filter);
    },
  },
  created() {

      let today = new Date();
      today.setHours(0, 0, 0, 0)

      let tomorrow = new Date()
      tomorrow.setDate(today.getDate() + 1)
      tomorrow.setHours(0, 0, 0, 0);

      // Sun - 0, Mon - 1
      let dayVal = today.getDay();

      let thisWeekFirstDate = new Date();
      thisWeekFirstDate.setDate(today.getDate() - dayVal);
      thisWeekFirstDate.setHours(0, 0, 0, 0);

      let thisWeekLastDate = new Date();
      thisWeekLastDate.setDate(today.getDate() + 6 - dayVal);
      thisWeekLastDate.setHours(0, 0, 0, 0);

      let nextWeekFirstDate = new Date();
      nextWeekFirstDate.setDate(today.getDate() - dayVal + 7);
      nextWeekFirstDate.setHours(0, 0, 0, 0);

      let nextWeekLastDate = new Date();
      nextWeekLastDate.setDate(today.getDate() - dayVal + 7 + 7);
      nextWeekLastDate.setHours(0, 0, 0, 0);

      let dateVal = today.getDate();

      // Jan - 0, Dec - 11
      let monthDay = this.monthDays[today.getMonth()];
      if(today.getMonth() == 1 && this.checkLeapYear(today.getFullYear())) {
        monthDay = 29;
      }

      let nextMonthDay = 0;
      if(today.getMonth() == 11) {
        nextMonthDay = this.monthDays[0];
      } else {
        nextMonthDay = this.monthDays[today.getMonth() + 1];
        if(nextMonthDay == 2 && this.checkLeapYear(today.getFullYear())) {
          nextMonthDay = 29;
        }
      }

      let thisMonthFirstDate = new Date();
      thisMonthFirstDate.setDate(today.getDate() - dateVal + 1);
      thisMonthFirstDate.setHours(0, 0, 0, 0);

      let thisMonthLastDate = new Date();
      thisMonthLastDate.setDate(monthDay);
      thisMonthLastDate.setHours(0, 0, 0, 0);

      this.dateRange.startDate = thisMonthFirstDate;
      this.dateRange.endDate = thisMonthLastDate;

      let nextMonthFirstDate = new Date();
      nextMonthFirstDate.setDate(today.getDate() + monthDay - dateVal + 1);
      nextMonthFirstDate.setHours(0, 0, 0, 0);

      let nextMonthLastDate = new Date();
      nextMonthLastDate.setDate(today.getDate() + monthDay - dateVal + nextMonthDay);
      nextMonthLastDate.setHours(0, 0, 0, 0);

    
      this.preDefinedRange = {
          'Today': [today, today],
          'Tomorrow': [tomorrow, tomorrow],
          'This week': [thisWeekFirstDate, thisWeekLastDate],
          'Next Week': [nextWeekFirstDate, nextWeekLastDate],
          'This month': [thisMonthFirstDate, thisMonthLastDate],
          'Next month': [nextMonthFirstDate, nextMonthLastDate],
          'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
      } 

    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.attDate = new Date();
    var date = new Date(),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    this.selectedDate = [date.getFullYear(), mnth, day].join("-");
    this.getAllAttendance();
    this.getLeaveAppln();
  },
  mounted() {
    // Set the initial number of items
    //this.totalRows = this.items.length;
  },
  methods: {
    calendarMonthsChange() {
      if(this.calendarMonths.startMonth == 1) {
        this.calendarMonths.endMonth = 12;
      } else {
        this.calendarMonths.endMonth = this.calendarMonths.startMonth - 1;
      }
    },
    removeHoliday(index) {
      if(this.holidays[index].id == 0) {
        this.holidays.splice(index , 1);
      } else {
        this.holidays[index].isDeleted = 1;
      }
    },
    downloadHolidays() {
      var fields = ["name", "date",];
      let fileName = "holidays.csv";
      this.convertToCSV(this.holidays, fields, fileName);
    },
    downloadDayAttendance() {
      var fields = ["name", "email", "designation", "teamName", "clockIn", "clockInRemarks", "clockOut", "clockOutRemarks", "remarks"];
      let fileName = "attendance.csv";
      this.convertToCSV(this.attendanceData, fields, fileName);
    },
    downloadLeaveAppln() {
      var fields = ["name", "email", "designation", "teamName", "reqFromType", "reqFromTime", "reqToType", "reqToTime", "leaveName", "leaveReason", "status", "appFromType", "approvedFromTime", "appToType", "approvedToTime", "comments"];
      let fileName = "leaveAppln.csv";
      this.convertToCSV(this.leaveData, fields, fileName);
    },
    toSnakeCase(inputString) {
      return inputString.split('').map((character) => {
          if (character == character.toUpperCase()) {
              return ' ' + character;
          } else {
              return character;
          }
      })
      .join('');
    },
    async convertToCSV(data, fields, fileName) {
      const json = data;
      //var fields = Object.keys(json[0])
      //var fields = ["name", "email", "designation", "teamName", "activeHours", "idleHours", "productivity"];
      var replacer = function(key, value) { return value === null ? '' : value } 
      var csv = json.map(function(row){
        return fields.map(function(fieldName){
          let data = row[fieldName];
          if(fieldName == 'date') {
            let calMonths = ["January", "February", "March","April", "May","June", "July","August", "September","October", "November", "December"];
            let d = new Date(data),
              mnth = ("0" + (d.getMonth() + 1)).slice(-2),
              day = ("0" + d.getDate()).slice(-2);

            data = day + ' ' + calMonths[parseInt(mnth) - 1] + ' ' + d.getFullYear();
          } else if(fieldName == 'reqFromType') {
            if(data == 2) {
              data = "2nd HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'reqToType') {
            if(data == 1) {
              data = "1st HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'appFromType') {
            if(data == 2) {
              data = "2nd HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'appToType') {
            if(data == 1) {
              data = "1st HALF";
            } else {
              data = "FULL DAY";
            }
          } else if(fieldName == 'status') {
            if(data == 0) {
              data = "PENDING";
            } else if(data == 1) {
              data = "APPROVED";
            } else if(data == 2) {
              data = "REJECTED";
            }
          }
          return JSON.stringify(data, replacer)
        }).join(',')
      })

      // Name, Email, Designation, Team Name, Active Hours, Idle Hours, Productivity
      for(var i = 0;i < fields.length;i++) {
        if(fields[i] == 'reqFromType') {
          fields[i] = 'Requested From Type';
        } else if(fields[i] == 'reqToType') {
          fields[i] = 'Requested To Type';
        } else if(fields[i] == 'appFromType') {
          fields[i] = 'Approved From Type';
        } else if(fields[i] == 'appToType') {
          fields[i] = 'Approved To Type';
        } else if(fields[i] == 'reqFromTime') {
          fields[i] = 'Requested From';
        } else if(fields[i] == 'reqToTime') {
          fields[i] = 'Requested To';
        } else if(fields[i] == 'approvedFromTime') {
          fields[i] = 'Approved From';
        } else if(fields[i] == 'approvedToTime') {
          fields[i] = 'Approved To';
        } else {
          fields[i] = this.toSnakeCase(fields[i]);
          fields[i] = fields[i].charAt(0).toUpperCase() + fields[i].slice(1);
        }
      }
      csv.unshift(fields.join(',')) // add header column
      csv = csv.join('\r\n');

      //console.log(csv);
      var exportedFilenmae = fileName;
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
    },
    checkLeapYear(year) {
      let leap = false;

      if (year % 4 == 0) {
        if (year % 100 == 0) {
          if (year % 400 == 0) {
            leap = true;
          } else {
            leap = false;
          }
        } else {
          leap = true;
        }
      } else {
        leap = false;
      }
      return leap;
    },
    openLeaveRejectModal(val) {
      this.rejectLeaveData.empId = val.empId;
      this.rejectLeaveData.leaveId = val.id;
      this.leaveRejectModal = true;
    },
    addHolidayRow() {
      let h = {};
      h.id = 0;
      h.name = '';
      h.date = '';
      h.isDeleted = 0;

      this.holidays.push(h);
    },
    async openLeaveActionModal(val){
      this.approveLeaveError = false;
      this.approveLeaveData = JSON.parse(JSON.stringify(val));
      this.approveLeaveData.approvedFromTime = new Date(this.approveLeaveData.reqFromTime);
      this.approveLeaveData.approvedToTime = new Date(this.approveLeaveData.reqToTime);
      this.approveLeaveData.appFromType = this.approveLeaveData.reqFromType == 0 ? true : false;
      this.approveLeaveData.appToType = this.approveLeaveData.reqToType == 0 ? true : false;

      this.leaveActionModal = true;
      this.leaveBalance = [];
      try {
        const response = await axios.get(`https://workrhythm.net:8090/employee/get_leave_balance`,{
          params: { companyId: this.loginData.companyId, empId: this.approveLeaveData.empId},
        }
        );
        if(response.data.success == "true") {
          this.leaveBalance = response.data.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    addCustomeLeave() {
      if(this.newLeaveName == null || this.newLeaveName == '')  {
        return;
      }
      let newCustomLeave = {};
      newCustomLeave.id = 12;
      newCustomLeave.name = this.newLeaveName;
      newCustomLeave.isEnabled = false;
      newCustomLeave.noOfDays = 0,
      newCustomLeave.type = 10;
      newCustomLeave.isCarriedForward = false;
      newCustomLeave.isAnyMonthlyMax = false;
      newCustomLeave.monthlyMax =  0;
      newCustomLeave.isDeleted =  0;

      this.leavePolicy.customLeaves.push(newCustomLeave);

      this.newLeaveName = '';
    },
    removeCustomeLeave(val) {
      if(val.id != 0) {
        val.isDeleted = 1;
      } else {
        let index = this.leavePolicy.customLeaves.indexOf(val);
        this.leavePolicy.customLeaves.splice(index , 1);
      }
      
    },
    openLeavePolicyModal() {
      this.getLeavePolicy();
      
        this.holidayYear = new Date();
        this.getHolidays();

        this.manageLeaves = true;
    },
    async getLeaveAppln() {
      this.leaveApplnLoader = true;
      var date = new Date(this.dateRange.startDate),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
      let sd  = [date.getFullYear(), mnth, day].join("-");
      
      date = new Date(this.dateRange.endDate),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
      let ed  = [date.getFullYear(), mnth, day].join("-");

      this.leaveData = [];
      try {
        const response = await axios.get(`https://workrhythm.net:8090/employee/get_leave_appln`,{
          params: { companyId: this.loginData.companyId, startDate: sd, endDate:  ed},
        }
        );

        if(response.data.success == "true") {
          this.leaveData = response.data.data;
        }
      } catch (error) {
        this.leaveApplnLoader = false;
      }
      this.leaveApplnLoader = false;
    },
    async getLeavePolicy() {
      try {
        const response = await axios.get(`https://workrhythm.net:8090/account/get_leave_policy`,{
          headers: {
            'Test-Header': 'test-value'
          },
          params: { companyId: this.loginData.companyId },
        }
        );

        if(response.data.success == "true") {
          if(response.data.data)
          this.leavePolicy = response.data.data;
        }
      } catch (error) {
       // console.log(error);
      }
      
    },
    async getHolidays() {
      var date = new Date(this.holidayYear),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        var fullDate = [date.getFullYear(), mnth, day].join("-");

      let year = fullDate.substring(0, 4);

        this.holidays = [];
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + `/account/get_holidays`, {
          params: { companyId: this.loginData.companyId, year: year },
        });

        if(response.data.success == "true") {
          this.calendarMonths.startMonth = response.data.data.startMonth;
          this.calendarMonths.endMonth = response.data.data.endMonth;
          this.holidays = response.data.data.holidays;

          for(var k = 0;k < this.holidays.length;k++) {
            var hd = new Date(this.holidays[k].date);
            this.holidays[k].date = hd;
          }
        } else {
          for(var i = 0;i < 10;i++) {
            this.addHolidayRow();
          }
        }
      } catch (error) {
       for(var j = 0;j < 10;j++) {
            this.addHolidayRow();
        }
      }
      this.manageLeaves = true;
    },
    submitLeavePolicy() {
      let formData = new FormData();

      formData.append("companyId", this.loginData.companyId);
      formData.append("leavePolicy", JSON.stringify(this.leavePolicy));

      axios
          .post(`https://workrhythm.net:8090/account/save_leave_policy`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Added!",
                text: "Leave Policy has been saved.",
                icon: 'success',
                onClose: () => {
                  //this.$router.push('/rules/list');
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });

    },
    rejectLeave() {
      let formData = new FormData();

      formData.append("companyId", this.loginData.companyId);
      formData.append("leaveId", this.rejectLeaveData.leaveId);
      formData.append("empId", this.rejectLeaveData.empId);
      formData.append("rejectLid", this.loginData.lid);
      formData.append("comments", this.rejectLeaveData.comments);

      axios
          .post(`https://workrhythm.net:8090/employee/reject_leave`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Added!",
                text: "Leave has been rejected.",
                icon: 'success',
                onClose: () => {
                 this.getLeaveAppln();
                 this.leaveRejectModal = false;
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });
    },
    approveLeave() {
      if(this.approveLeaveData.approvedFromTime == null || this.approveLeaveData.approvedFromTime == '') {
        this.approveLeaveError = true;
        return;
      }

      if(this.approveLeaveData.approvedToTime == null || this.approveLeaveData.approvedToTime == '') {
         this.approveLeaveError = true;
        return;
      }
       this.approveLeaveError = false;
      let appFromType = this.approveLeaveData.appFromType == true ? 0 : 2;
      let appToType = this.approveLeaveData.appToType == true ? 0 : 1;
      var date = new Date(this.approveLeaveData.approvedFromTime),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);

      let from = [date.getFullYear(), mnth, day].join("-");

      date = new Date(this.approveLeaveData.approvedToTime),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);

      let to = [date.getFullYear(), mnth, day].join("-");

      let formData = new FormData();

      formData.append("companyId", this.loginData.companyId);
      formData.append("empId", this.approveLeaveData.empId);
      formData.append("leaveId", this.approveLeaveData.id);
      formData.append("approveLid", this.loginData.lid);
      formData.append("appFromType", appFromType);
      formData.append("from", from);
      formData.append("appToType", appToType);
      formData.append("to", to);
      formData.append("comments", this.approveLeaveData.comments);

      axios
          .post(`https://workrhythm.net:8090/employee/approve_leave`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Added!",
                text: "Leave has been Approved.",
                icon: 'success',
                onClose: () => {
                 this.getLeaveAppln();
                 this.leaveActionModal = false;
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });
    },
    validateHoliday(val) {
      if(val.name == null || val.name == '') {
        return false;
      }
      if(val.date == null) {
        return false;
      }
      if(val.id == 0 && val.isDeleted == 1) {
        return false;
      }

      return true;
    },
    submitHolidays() {
      let sendData = [];
      for(var i = 0;i < this.holidays.length;i++) {
        if(this.validateHoliday(this.holidays[i])) {
          var date = new Date(this.holidays[i].date),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);

          var fullDate = [date.getFullYear(), mnth, day].join("-");

          let h = {};
          h.id = this.holidays[i].id;
          h.name = this.holidays[i].name;
          h.date = fullDate;
          h.isDeleted = this.holidays[i].isDeleted;

          sendData.push(h);
        }
      }

      let formData = new FormData();

      formData.append("companyId", this.loginData.companyId);
      formData.append("startMonth", this.calendarMonths.startMonth);
      formData.append("endMonth",this.calendarMonths.endMonth);
      formData.append("holidays", JSON.stringify(sendData));

      axios
          .post(`https://workrhythm.net:8090/account/save_holidays`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Saved!",
                text: "Holidays has been saved.",
                icon: 'success',
                onClose: () => {
                  //this.$router.push('/rules/list');
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });

    },
    getColLabel(colName) {
      return this.$t(colName);
    },
    onDateChange() {
      if(this.attDate == null) {
        return;
      }
      var date = new Date(this.attDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      this.getAllAttendance();
    },
     async getAllAttendance() {
       this.attLoader = true;
       this.attendanceData = [];
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all_attendance", {
          params: { companyId: this.loginData.companyId, date: this.selectedDate },
        });

         if(response.data.success == "true") {
           if(response.data.data.data.length > 0) {
             this.attendanceData = response.data.data.data;
          }
          
          this.attSummaryData.present = response.data.data.present;
          this.attSummaryData.absent = response.data.data.absent;
          this.attSummaryData.late = response.data.data.late;
          this.attLoader = false;
        }
      } catch (error) {
        //console.log(error);
        this.attLoader = false;
      }
      this.attLoader = false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.type === "Sell") return "table-success";
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.attendance.text')" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="height: calc(100vh - 228px);">
          
            
            <div>
              <b-tabs content-class="mt-3" nav-class="nav-tabs-custom">
                <b-tab :title="$t('menuitems.attendance.attendance')" active>
                <div class="row">
                  <div class="col-sm-12 col-md-8"></div>
                  <div class="col-sm-12 col-md-4 text-end">
                  <button class="btn btn-outline-primary btn-sm" @click="downloadDayAttendance"><i class="bx bx-download me-1"></i> Download</button>
                  </div>
                </div>
                  <div class="row mt-4">
                    <div class="col-sm-12 col-md-4">
                      <!--<div id="tickets-table_length" class="dataTables_length">-->
                        <label class="d-inline-flex align-items-center fw-normal">
                          <!-- &nbsp;
                          <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                            class="form-control form-select form-select-sm"
                          ></b-form-select
                          >&nbsp;entries -->
                          <date-picker v-model="attDate" @change="onDateChange" :first-day-of-week="1" placeholder="select date" input-class="focus:outline-none"  lang="en"></date-picker>
                        </label>
                      <!-- </div> -->
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <span class="fw-bold mb-2 fs-5">{{ $t('menuitems.attendance.present') }} : {{attSummaryData.present}}</span> <span class="fw-bold mb-2 ms-4 fs-5">{{ $t('menuitems.attendance.absent') }} : {{attSummaryData.absent}}</span><span class="fw-bold mb-2 ms-4 fs-5">{{ $t('menuitems.attendance.late') }} : {{attSummaryData.late}}</span>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-4">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                      >
                        <label class="d-inline-flex align-items-center">
                          {{ $t('menuitems.attendance.search') }}:
                          <b-form-input
                            v-model="filter"
                            type="search"
                            class="form-control form-control-sm ms-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>
                  <!-- Table -->
                  <div class="is-loading">
                    <div class="preloader-component" v-show="attLoader" style="top: 10%;">
                      <div class="status">
                        <div class="spinner-chase">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <div v-if="attendanceData.length > 0" class="table-responsive table-hover mb-0" style="height: calc(100vh - 380px);">
                      <b-table
                        hover
                        sticky-header
                        thead-class="bg-light text-dark"
                        :items="attendanceData"
                        :fields="fields"
                        responsive="sm"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :head-variant="headVariant"
                        @filtered="onFiltered"
                      >
                      <span v-for="f in fields" :key="f.key" :slot="'HEAD_' + f.key" scope="{ field }">
                      {{ $t(f.label) }}
                    </span>
                      <template #cell(clockIn)="data">
                        <span class="font-weight-bolder">{{data.item.clockIn}}</span><br/> <span :class="`badge font-size-8 bg-${data.item.clockInColor}`">{{data.item.clockInRemarks}}</span>
                      </template>
                      <template #cell(clockOut)="data">
                        {{data.item.clockOut}}<br/> <span :class="`badge font-size-8 bg-${data.item.clockOutColor}`">{{data.item.clockOutRemarks}}</span>
                      </template>
                      <template #cell(view)="data">
                        <router-link :to="{ name: 'attendance-details', params: { data: data.item.empId } }" class="font-size-14">
                          {{ $t('menuitems.attendance.viewDetails') }} <i class="bx bx-right-arrow-alt"></i>
                        </router-link>
                      </template>
                      </b-table>
                    </div>
                  </div>
                  <div v-if="attendanceData.length <= 0" style="margin-top: 15%;margin-left: 40%;">
                  <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180"><br />
                  <span class="mt-2 text-secondary fw-bold fs-3">{{ $t('menuitems.attendance.noAttendanceFound') }}</span>
                </div>
                </b-tab>
                <!--<b-tab :title="$t('menuitems.attendance.leaves')">
                  <div class="row mt-4">
                    <div class="col-md-8">
                      <button class="btn btn-outline-warning btn-sm" @click="openLeavePolicyModal"><i class="fas fa-calendar-plus me-1"></i> {{ $t('menuitems.attendance.setLeavePolicy') }}</button>
                    </div>
                    
                    <div class="col-md-4 text-end">
                        <button class="btn btn-outline-primary btn-sm" @click="downloadLeaveAppln"><i class="bx bx-download me-1"></i> {{ $t('menuitems.attendance.download') }}</button>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-sm-12  col-md-4 mb-2">
                      <date-range-picker
                            ref="picker"
                              :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                              :showDropdowns="true"
                              :ranges="preDefinedRange"
                              @update="getLeaveAppln"
                              v-model="dateRange"
                              :opens="'right'"
                              :placeholder="'Select Date'"
                              style="min-width: 188px;"
                          >
                          </date-range-picker>
                    </div>
                    <div class="col-md-3"></div>
                    <div class="col-md-2 mb-2  text-end" style="margin-top: -8px;">
                    <b-dropdown  style="height: 30px;" dropleft variant="outline-secondary" class="m-2" checkbox-menu allow-focus>
                        <template  #button-content >
                          <i class="bx bxs-filter-alt ps-2 pe-1"></i> <span class="pe-3">{{ $t('menuitems.screenshots.filters') }}</span>
                        </template>
                      <b-dropdown-form>
                        <b-form-checkbox
                            v-model="leaveDataFilters.pending"
                            class="form-check mt-2 ms-2"
                          >
                           {{ $t('menuitems.attendance.pending') }}
                          </b-form-checkbox>
                        <b-form-checkbox
                            v-model="leaveDataFilters.approved"
                            class="form-check ms-2"
                          >
                            {{ $t('menuitems.attendance.approved') }}
                          </b-form-checkbox>
                          <b-form-checkbox
                            v-model="leaveDataFilters.rejected"
                            class="form-check ms-2"
                          >
                            {{ $t('menuitems.attendance.rejected') }}
                          </b-form-checkbox>
                      </b-dropdown-form>
                    </b-dropdown>
                    </div>
                    <div class="col-sm-12 col-md-3 text-end">
                      
                        <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('menuitems.teams.search')"
                          v-model="filterLeaveApplnValue"
                          style="height: 30px;"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="is-loading">
                    <div class="preloader-component" v-show="leaveApplnLoader" style="top: 10%;">
                      <div class="status">
                        <div class="spinner-chase">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    
                      <div v-if="searchLeaveApplnEvents.length > 0" class="table-responsive table-hover">
                        <table class="table table-fixed">
                          <thead class="table-light">
                            <tr>
                              <th scope="col">{{ $t('menuitems.attendance.details') }}</th>
                              <th scope="col">{{ $t('menuitems.attendance.from') }} - {{ $t('menuitems.attendance.To') }}</th>
                              <th scope="col">{{ $t('menuitems.attendance.reason') }}</th>
                              <th scope="col">{{ $t('menuitems.attendance.leaveType') }}</th>
                              <th scope="col">{{ $t('menuitems.attendance.status') }}</th>
                              <th scope="col">{{ $t('menuitems.attendance.action') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(val, index) in searchLeaveApplnEvents" :key="index">
                              <td>
                                  {{ val.name }}<br/>
                                  <span class="text-secondary">{{ val.email }}</span><br/>
                                  <span class="text-secondary">{{ val.designation }}</span>
                                </td>
                              <td>
                                <span>{{ $t('menuitems.attendance.from') }} <span v-if="val.reqFromType == 2">{{ $t('menuitems.attendance.secondHalfOf') }} </span>{{ val.reqFromTime }}</span><span> {{ $t('menuitems.attendance.to') }} <span  v-if="val.reqToType == 1">{{ $t('menuitems.attendance.firstHalfOf') }} </span>{{ val.reqToTime }}</span>
                              <td>
                                {{ val.leaveReason }}
                              </td>
                              <td>
                                {{ val.leaveName }}
                              </td>
                              <td>
                                <span v-if="val.status == 0" class="badge badge-soft-info font-size-9">{{ $t('menuitems.attendance.pending') }}</span>
                                <span v-if="val.status == 1" class="badge badge-soft-success font-size-9">{{ $t('menuitems.attendance.approved') }}</span>
                                <span v-if="val.status == 2" class="badge badge-soft-danger font-size-9">{{ $t('menuitems.attendance.rejected') }}</span>
                              </td>
                              <td>
                                <b-dropdown
                                  class="card-drop"
                                  variant="white"
                                  menu-class="dropdown-menu-end"
                                  right
                                  toggle-class="p-0"
                                >
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-dots-horizontal font-size-18"></i>
                                  </template>
                                  <b-dropdown-item v-if="val.status == 0 || val.status == 2" href="javascript: void(0);" @click="openLeaveActionModal(val)"
                                    ><i class="bx bx-check-circle me-2" ></i> {{ $t('menuitems.attendance.approve') }}</b-dropdown-item
                                  >
                                  <b-dropdown-item  v-if="val.status == 1" href="javascript: void(0);" disabled
                                    ><i class="bx bx-check-circle me-2" ></i> {{ $t('menuitems.attendance.approved') }}</b-dropdown-item
                                  >
                                  <b-dropdown-item v-if="val.status == 0 || val.status == 1" href="javascript: void(0);" @click="openLeaveRejectModal(val)"
                                    ><i class="bx bx-x-circle me-2" ></i> {{ $t('menuitems.attendance.reject') }}</b-dropdown-item
                                  ><b-dropdown-item v-if="val.status == 2" href="javascript: void(0);" disabled
                                    ><i class="bx bx-x-circle me-2" ></i> {{ $t('menuitems.attendance.rejected') }}</b-dropdown-item
                                  >
                                  <b-dropdown-item href="javascript: void(0);"
                                    >
                                    <router-link :to="{ name: 'attendance-details', params: { data: val.empId  } }"  class="text-dark">
                                      <i class="bx bxs-report me-2"></i> {{ $t('menuitems.attendance.viewDetails') }}
                                    </router-link>
                                    </b-dropdown-item
                                  >
                                </b-dropdown>
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>
                        
                      </div>
                    
                    <div v-if="searchLeaveApplnEvents.length <= 0" style="margin-top: 8%;margin-left: 40%;">
                      <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180"><br />
                      <span class="mt-2 text-secondary fw-bold fs-3">No Leave Found</span>
                    </div>
                  </div>
                </b-tab>-->
                <!--<b-tab title="Summary">
                  <simplebar style="max-height: calc(100vh - 211px);overflow-x: hidden;" >
                  <div class="row">
                    <div class="col-md-10"></div>
                    <div class="col-md-2">
                      <date-picker
                        type="month"
                        lang="en"
                        confirm
                        placeholder="Select Month"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                    <apexchart
                      class="apex-charts"
                      height="350"
                      type="line"
                      dir="ltr"
                      :series="mixedChart.series"
                      :options="mixedChart.chartOptions"
                    ></apexchart>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-md-8"></div>
                    <div class="col-md-2 text-end">
                    </div>
                    
                    <div class="col-md-2 text-end">
                        <button class="btn btn-outline-primary btn-sm"><i class="bx bx-download"></i> Download</button>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-sm-12  col-md-4 mb-2">
                      <date-range-picker
                            ref="picker"
                              :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                              :showDropdowns="true"
                              :ranges="preDefinedRange"
                              v-model="dateRange"
                              :opens="'right'"
                              :placeholder="'Select Date'"
                              style="min-width: 188px;"
                          >
                          </date-range-picker>
                    </div>
                    <div class="col-md-5"></div>
                    <div class="col-sm-12 col-md-3 text-end">
                      
                        <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('menuitems.teams.search')"
                          v-model="filterValue"
                          style="height: 30px;"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive table-hover mb-0" style="height: calc(100vh - 300px);">
                    <table class="table align-middle table-nowrap table-hover">
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Details</th>
                          <th scope="col">Present Days</th>
                          <th scope="col">Absent Days</th>
                          <th scope="col">Late days</th>
                          <th scope="col">Overtime Hours</th>
                          <th scope="col">Leave Days</th>
                          <th scope="col">Attendance</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                              Victor<br/>
                              <span class="text-secondary">victor@workrhythm.net</span><br/>
                              <span class="text-secondary">SDE</span>
                            </td>
                          <td>
                            <span class="fw-bold">10</span>
                          <td>
                            <span class="fw-bold">10</span>
                          </td>
                          <td>
                            <span class="fw-bold">10</span>
                          </td>
                          <td>
                            <span class="fw-bold">9 hr 23 mins</span>
                          </td>
                          <td>
                            <span class="fw-bold">5</span>
                          </td>
                          <td>
                            <div class="row">
                              <div class="col-md-6">
                                <attchart
                                :seriesvalue="70"
                                :Chartcolor="'#f1734f'"
                              />
                              </div>
                              
                              <div class="col-md-6 mt-4">
                                <span class="fw-bold" style="margin-bottom : 10px;">70%</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                  </div>
                  </simplebar>
                </b-tab>-->
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="manageLeaves" size="lg" centered :title="$t('menuitems.attendance.manageLeaves')" hide-footer>
        <b-tabs pills justified content-class="p-3 text-muted"> 
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-clipboard-list"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('menuitems.attendance.leavePolicy') }}</span>
            </template>
            <b-card-text style="height: calc(100vh - 328px);">
              <div class="row mb-4">
                <b-col md="4" sm="12">
                  
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('menuitems.attendance.leaveName')"
                    v-model="newLeaveName"
                    style="height: 32px;"
                  />
                </b-col>
                <b-col md="4" sm="12">
                  <button type="button" class="btn btn-info btn-md ms-2" @click="addCustomeLeave" style="height: 32px;">
                    {{ $t('menuitems.attendance.addNewLeave') }}
                  </button>
                </b-col>
              </div>
              <div>
                <simplebar style="max-height: calc(100vh - 408px);overflow-x: hidden;" >
                
                <b-tabs
                  pills
                  vertical
                  nav-class="p-0"
                  nav-wrapper-class="col-sm-3"
                  content-class="pt-0 px-2 text-muted"
                >
                  <b-tab title="Privilege Leave (PL)" active title-item-class="mb-2">
                    <b-card-text>
                      <h4>Privilege Leave (PL)/ Earned Leave (EL)</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.privgLeave.isEnabled"
                        />
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          {{ $t('menuitems.attendance.noOfDays') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            v-model="leavePolicy.privgLeave.noOfDays"
                            :disabled="leavePolicy.privgLeave.isEnabled == false"
                            placeholder="days"
                          ></b-form-input>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          {{ $t('menuitems.attendance.minmEligiPeriod') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            v-model="leavePolicy.privgLeave.minmEligiblePeriod"
                            :disabled="leavePolicy.privgLeave.isEnabled == false"
                            placeholder="days"
                          ></b-form-input>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-4">
                            {{ $t('menuitems.attendance.isCarriedForward') }}
                          </div>
                          <div class="col-md-3">
                            <div class="form-check form-switch form-switch-sm mb-4 mt-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :disabled="leavePolicy.privgLeave.isEnabled == false"
                            v-model="leavePolicy.privgLeave.isCarriedForward"
                          />
                        </div>
                        </div>
                    
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Casual Leave (CL)" title-item-class="mb-2">
                    <b-card-text>
                      <h4>Casual Leave (CL)</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.casualLeave.isEnabled"
                        />
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                         {{ $t('menuitems.attendance.noOfDays') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            v-model="leavePolicy.casualLeave.noOfDays"
                            :disabled="leavePolicy.casualLeave.isEnabled == false"
                          ></b-form-input>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-4">
                            {{ $t('menuitems.attendance.isCarriedForward') }}
                          </div>
                          <div class="col-md-3">
                            <div class="form-check form-switch form-switch-sm mb-4 mt-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="leavePolicy.casualLeave.isCarriedForward"
                            :disabled="leavePolicy.casualLeave.isEnabled == false"
                          />
                        </div>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-4">
                            {{ $t('menuitems.attendance.isAnyMonthlyMax') }}
                          </div>
                          <div class="col-md-3">
                            <div class="form-check form-switch form-switch-sm mb-4 mt-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="leavePolicy.casualLeave.isAnyMonthlyMax"
                            :disabled="leavePolicy.casualLeave.isEnabled == false"
                          />
                        </div>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-4">
                           {{ $t('menuitems.attendance.monthlyMaxDays') }}
                          </div>
                          <div class="col-md-3">
                          <b-form-input
                            for="number"
                            v-model="leavePolicy.casualLeave.monthlyMax"
                            :disabled="leavePolicy.casualLeave.isEnabled == false || leavePolicy.casualLeave.isAnyMonthlyMax == false"
                          ></b-form-input>
                        </div>
                    
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Sick Leave (SL)" title-item-class="mb-2">
                    <b-card-text>
                      <h4>Sick Leave (SL)</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.sickLeave.isEnabled"
                        />
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                         {{ $t('menuitems.attendance.noOfDays') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            :disabled="leavePolicy.sickLeave.isEnabled == false"
                            v-model="leavePolicy.sickLeave.noOfDays"
                          ></b-form-input>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-4">
                            {{ $t('menuitems.attendance.isCarriedForward') }}
                          </div>
                          <div class="col-md-3">
                            <div class="form-check form-switch form-switch-sm mb-4 mt-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :disabled="leavePolicy.sickLeave.isEnabled == false"
                            v-model="leavePolicy.sickLeave.isCarriedForward"
                          />
                        </div>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-4">
                            {{ $t('menuitems.attendance.isAnyMonthlyMax') }}
                          </div>
                          <div class="col-md-3">
                            <div class="form-check form-switch form-switch-sm mb-4 mt-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :disabled="leavePolicy.sickLeave.isEnabled == false"
                            v-model="leavePolicy.sickLeave.isAnyMonthlyMax"
                          />
                        </div>
                        </div>
                    
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-4">
                            {{ $t('menuitems.attendance.monthlyMaxDays') }}
                          </div>
                          <div class="col-md-3">
                          <b-form-input
                            for="number"
                            :disabled="leavePolicy.sickLeave.isEnabled == false || leavePolicy.sickLeave.isAnyMonthlyMax == false"
                            v-model="leavePolicy.sickLeave.monthlyMax"
                          ></b-form-input>
                        </div>
                    
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Maternity Leave (ML)">
                    <b-card-text>
                      <h4>Maternity Leave (ML)</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.maternityLeave.isEnabled"
                        />
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          {{ $t('menuitems.attendance.noOfDays') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            :disabled="leavePolicy.maternityLeave.isEnabled == false"
                            v-model="leavePolicy.maternityLeave.noOfDays"
                          ></b-form-input>
                        </div>
                    
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Marriage Leave" title-item-class="mb-2">
                    <b-card-text>
                      <h4>Marriage Leave</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.marriageLeave.isEnabled"
                        />
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          {{ $t('menuitems.attendance.noOfDays') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            :disabled="leavePolicy.marriageLeave.isEnabled == false"
                            v-model="leavePolicy.marriageLeave.noOfDays"
                          ></b-form-input>
                        </div>
                    
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Paternity Leave" title-item-class="mb-2">
                  <b-card-text>
                      <h4>Paternity Leave</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.paternityLeave.isEnabled"
                        />
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          {{ $t('menuitems.attendance.noOfDays') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            :disabled="leavePolicy.paternityLeave.isEnabled == false"
                            v-model="leavePolicy.paternityLeave.noOfDays"
                          ></b-form-input>
                        </div>
                    
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Bereavement Leave" title-item-class="mb-2">
                    <b-card-text>
                      <h4>Bereavement Leave</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.bereavLeave.isEnabled"
                        />
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                         {{ $t('menuitems.attendance.noOfDays') }}
                        </div>
                        <div class="col-md-3">
                          <b-form-input
                            for="number"
                            :disabled="leavePolicy.bereavLeave.isEnabled == false"
                            v-model="leavePolicy.bereavLeave.noOfDays"
                          ></b-form-input>
                        </div>
                    
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Compensatory Off (comp-off)" title-item-class="mb-2">
                    <b-card-text>
                      <h4>Compensatory Off (comp-off)</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.compOffLeave.isEnabled"
                        />
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Leave Without Pay (LWP)">
                    <b-card-text>
                      <h4>Leave Without Pay (LWP)</h4>
                      <div class="form-check form-switch form-switch-md mb-4 mt-4">
                        <label class="form-check-label" for="SwitchCheckSizemd"
                          >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="leavePolicy.lwpLeave.isEnabled"
                        />
                      </div>
                      
                    </b-card-text>
                  </b-tab>
                  <template v-for="(l, index) in leavePolicy.customLeaves"  >
                    <b-tab :title="l.name" :key="index" v-if="l.isDeleted == 0">
                      <b-card-text>
                        <h4 v-if="editLeaveName == false">{{ l.name }} <i style="cursor: pointer;" @click="editLeaveName = true" class="bx bx-edit fs-5 text-warning"></i></h4>
                        <b-row v-else>
                          <b-col md = "4">
                            <b-form-input
                                for="text"
                                placeholder="Enter Leave Name"
                                v-model="l.name"
                                style="height : 28px;"
                              ></b-form-input>
                          </b-col>
                          <b-col md = "2">
                            <button class="btn btn-primary btn-sm"  @click="editLeaveName = false"> {{ $t('menuitems.attendance.save') }}</button>
                          </b-col>
                        </b-row>
                        <div class="row">
                          <div class="col-md-10">
                          </div>
                          <div class="col-md-2">
                            <button type="button" class="btn btn-danger btn-sm" @click="removeCustomeLeave(l)">{{ $t('menuitems.attendance.remove') }}</button>
                          </div>
                        </div>
                              <div class="form-check form-switch form-switch-md mb-4 mt-4">
                                <label class="form-check-label" for="SwitchCheckSizemd"
                                  >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                                >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="l.isEnabled"
                                />
                                
                              </div>
                        <div class="row mb-3">
                          <div class="col-md-4">
                           {{ $t('menuitems.attendance.noOfDays') }}
                          </div>
                          <div class="col-md-3">
                            <b-form-input
                              for="number"
                              :disabled="l.isEnabled == false"
                              v-model="l.noOfDays"
                            ></b-form-input>
                          </div>
                      
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4">
                              {{ $t('menuitems.attendance.isCarriedForward') }}
                            </div>
                            <div class="col-md-3">
                              <div class="form-check form-switch form-switch-sm mb-4 mt-2">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :disabled="l.isEnabled == false"
                              v-model="l.isCarriedForward"
                            />
                          </div>
                          </div>
                      
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4">
                              {{ $t('menuitems.attendance.isAnyMonthlyMax') }}
                            </div>
                            <div class="col-md-3">
                              <div class="form-check form-switch form-switch-sm mb-4 mt-2">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :disabled="l.isEnabled == false"
                              v-model="l.isAnyMonthlyMax"
                            />
                          </div>
                          </div>
                      
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4">
                             {{ $t('menuitems.attendance.monthlyMaxDays') }}
                            </div>
                            <div class="col-md-3">
                            <b-form-input
                              for="number"
                              :disabled="l.isEnabled == false || l.isAnyMonthlyMax == false"
                              v-model="l.monthlyMax"
                            ></b-form-input>
                          </div>
                      
                        </div>
                      </b-card-text>
                    </b-tab>
                  </template>
                </b-tabs>
                
                </simplebar>
              </div>
              <div class="row mt-4">
                <b-col md="8">
                  <span class="text-danger">{{ $t('menuitems.attendance.leaveNote') }}</span>
                </b-col>
                <b-col md="4" class="text-end">
                  <button type="button" class="btn btn-primary btn-md ms-2" @click="submitLeavePolicy">
                    {{ $t('menuitems.attendance.save') }}
                  </button>
                </b-col>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-calendar-check"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('menuitems.attendance.calendar') }} {{ $t('menuitems.attendance.and') }} {{ $t('menuitems.attendance.holidays') }}</span>
            </template>
            <b-card-text style="height: calc(100vh - 328px);">
              <div class="row mb-4">
                <b-col md="3" class="mt-4">
                  <span>
                    {{ $t('menuitems.attendance.calendar') }} {{ $t('menuitems.attendance.year') }}
                  </span>
                </b-col>
                <b-col md="1" class="mt-4">
                  <span class="fw-bold">
                   {{ $t('menuitems.attendance.from') }}
                  </span>
                </b-col>
                <b-col md="3" class="mt-4">
                  <b-form-select
                    class="form-select mb-3"
                    v-model="calendarMonths.startMonth"
                    v-on:change="calendarMonthsChange"
                  >
                    <b-form-select-option :value="1"
                      >January</b-form-select-option
                    >
                    <b-form-select-option :value="2"
                      >February</b-form-select-option
                    >
                    <b-form-select-option :value="3"
                      >March</b-form-select-option
                    >
                    <b-form-select-option :value="4"
                      >April</b-form-select-option
                    >
                    <b-form-select-option :value="5"
                      >May</b-form-select-option
                    >
                    <b-form-select-option :value="6"
                      >June</b-form-select-option
                    >
                    <b-form-select-option :value="7"
                      >July</b-form-select-option
                    >
                    <b-form-select-option :value="8"
                      >August</b-form-select-option
                    >
                    <b-form-select-option :value="9"
                      >September</b-form-select-option
                    >
                    <b-form-select-option :value="10"
                      >October</b-form-select-option
                    >
                    <b-form-select-option :value="11"
                      >November</b-form-select-option
                    >
                    <b-form-select-option :value="12"
                      >December</b-form-select-option
                    >
                  </b-form-select>
                </b-col>
                <b-col md="1" class="mt-4">
                </b-col>
                <b-col md="1" class="mt-4">
                  <span class="fw-bold">
                   {{ $t('menuitems.attendance.To') }}
                  </span>
                </b-col>
                <b-col md="3" class="mt-4">
                  <b-form-select
                    class="form-select mb-3"
                    v-model="calendarMonths.endMonth"
                    disabled
                  >
                    <b-form-select-option :value="1"
                      >January</b-form-select-option
                    >
                    <b-form-select-option :value="2"
                      >February</b-form-select-option
                    >
                    <b-form-select-option :value="3"
                      >March</b-form-select-option
                    >
                    <b-form-select-option :value="4"
                      >April</b-form-select-option
                    >
                    <b-form-select-option :value="5"
                      >May</b-form-select-option
                    >
                    <b-form-select-option :value="6"
                      >June</b-form-select-option
                    >
                    <b-form-select-option :value="7"
                      >July</b-form-select-option
                    >
                    <b-form-select-option :value="8"
                      >August</b-form-select-option
                    >
                    <b-form-select-option :value="9"
                      >September</b-form-select-option
                    >
                    <b-form-select-option :value="10"
                      >October</b-form-select-option
                    >
                    <b-form-select-option :value="11"
                      >November</b-form-select-option
                    >
                    <b-form-select-option :value="12"
                      >December</b-form-select-option
                    >
                  </b-form-select>
                </b-col>
              </div>
              <div class="row mb-4">
                <b-col md="3" class="mt-4">
                  <h5>
                   {{ $t('menuitems.attendance.holidays') }}
                  </h5>
                </b-col>
                <b-col md="5" class="mt-4">
                </b-col>
                <b-col md="3" class="mt-4">
                  <date-picker
                    type="year"
                    lang="en"
                    confirm
                    @change="getHolidays"
                    v-model="holidayYear"
                    placeholder="Select Year"
                  ></date-picker>
                </b-col>
                 <b-col md="1" class="mt-4">
                   <button class="btn btn-outline-primary" @click="downloadHolidays"><i class="bx bx-download"></i></button>
                </b-col>
              </div>
              <simplebar style="max-height: calc(100vh - 568px);">
              <div class="table-responsive">
                <table class="table table-centered table-nowrap align-middle">
                  <thead>
                    <tr>
                      <th >{{ $t('menuitems.employee.sNo') }}</th>
                      <th class="thead-width">{{ $t('menuitems.attendance.holidayName') }}  <i class="mdi mdi-asterisk text-danger font-size-10"></i></th>
                      <th class="thead-width">{{ $t('menuitems.attendance.date') }}  <i class="mdi mdi-asterisk text-danger font-size-10"></i></th>
                      <th>{{ $t('menuitems.employee.action') }} </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(holiday, index) in holidays">
                    <tr :key="index" v-if="holiday.isDeleted == 0">
                        <td><span class="fw-bold">{{ index + 1 }}</span></td>
                        <td>
                            <input
                              type="text"
                              class="form-control"
                              v-model="holiday.name"

                              :placeholder="'Holiday Name'"
                            />
                        </td>
                        <td>
                          <date-picker v-model="holiday.date" :first-day-of-week="1" lang="en" placeholder="Select Date" confirm></date-picker>  
                        </td>
                        
                      <td><i style="cursor: pointer;" @click="removeHoliday(index)" class="text-danger fs-5 bx bx-minus-circle"></i></td>
                    </tr>
                    
                    </template>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><button type="button" class="btn btn-success btn-md" @click="addHolidayRow">
                          {{ $t('menuitems.attendance.addNew') }}
                      </button></td>
                        
                    </tr>
                  </tbody>
                </table>
              </div>
            </simplebar>
            <div class="row mt-4">
                <b-col md="8">
                  <span class="text-danger">{{ $t('menuitems.attendance.holidayNote') }}</span>
                </b-col>
                <b-col md="4" class="text-end">
                  <button type="button" class="btn btn-primary btn-md ms-2" @click="submitHolidays">
                    {{ $t('menuitems.attendance.save') }}
                  </button>
                </b-col>
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
       
    </b-modal>
    <b-modal v-model="leaveActionModal" size="lg" centered :title="$t('menuitems.attendance.approveLeave')" hide-footer>
    <h5 class="card-title mb-3 me-2">{{ $t('menuitems.attendance.leaveBalance') }}</h5>
      <div class="row mb-4">
        <simplebar style="max-height: calc(100vh - 698px);overflow-x: hidden;" >
          <div class="table-responsive table-hover mb-0">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t('menuitems.attendance.leave') }}</th>
                  <th scope="col">{{ $t('menuitems.attendance.used') }}</th>
                  <th scope="col">{{ $t('menuitems.attendance.available') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in leaveBalance" :key="index">
                  <td>
                      {{ data.leaveName }}
                  <td>
                    <span class="fw-bold">{{ data.used }}</span>
                  <td>
                    <span class="fw-bold">{{ data.available }} <span v-if="data.carried > 0" >( {{ data.carried }} )<sup><i class="bx bx-question-mark" style="cursor: pointer;" v-b-tooltip.hover :title="$t('menuitems.attendance.carried')"></i></sup></span></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </simplebar>
      </div>
      <div class="col-12">
        <div class="row mb-4">
          <div class="col-md-4">
            {{ $t('menuitems.attendance.leave') }} : 
          </div>
          <div class="col-md-4">
            <span class="fw-bold">{{ approveLeaveData.leaveName }}</span>
            </div>

        </div>
        <div class="row mb-3">
          <div class="col-md-4" :class="{
              'text-danger': approveLeaveError,
            }">
            {{ $t('menuitems.attendance.from') }} : <sup><i class="mdi mdi-asterisk text-danger font-size-10"></i></sup>
          </div>
          <div class="col-md-4">
            <date-picker v-model="approveLeaveData.approvedFromTime" :first-day-of-week="1" lang="en" :placeholder="$t('menuitems.reports.selectDate')" confirm></date-picker>
          </div>
          <div class="col-md-4">
              <b-form-checkbox
              class="mb-3"
              checked
              plain
              v-model="approveLeaveData.appFromType"
              >{{ $t('menuitems.attendance.fullDay') }}</b-form-checkbox
            >
           </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4" :class="{
              'text-danger': approveLeaveError,
            }">
            {{ $t('menuitems.attendance.To') }} : <sup><i class="mdi mdi-asterisk text-danger font-size-10"></i></sup>
          </div>
          <div class="col-md-4">
            <date-picker v-model="approveLeaveData.approvedToTime" :first-day-of-week="1" lang="en" :placeholder="$t('menuitems.reports.selectDate')" confirm></date-picker>
          </div>
           <div class="col-md-4">
              <b-form-checkbox
              class="mb-3"
              checked
              v-model="approveLeaveData.appToType"
              plain
              >{{ $t('menuitems.attendance.fullDay') }}</b-form-checkbox
            >
           </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            {{ $t('menuitems.attendance.comments') }} : 
          </div>
          <div class="col-md-6">
            <textarea
            v-model="approveLeaveData.comments"
              name="description"
              class="form-control"
            ></textarea>
            </div>

        </div>
        <div class="text-end mt-3">
        <b-button variant="light" @click="leaveActionModal = false">{{ $t('menuitems.attendance.close') }}</b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="approveLeave"
          >{{ $t('menuitems.attendance.approve') }}</b-button
        >
      </div>
      </div>
    </b-modal>

    <b-modal v-model="leaveRejectModal" size="md" centered :title="$t('menuitems.attendance.rejectLeave')" hide-footer>
      <div class="col-12">
        <div class="row mb-4">
          <div class="col-md-4">
            {{ $t('menuitems.attendance.comments') }} : 
          </div>
          <div class="col-md-8">
            <textarea
              name="description"
              class="form-control"
              v-model="rejectLeaveData.comments"
            ></textarea>
            </div>

        </div>
        <div class="text-end mt-3">
        <b-button variant="light" @click="leaveRejectModal = false">{{ $t('menuitems.attendance.close') }}</b-button>
        <b-button type="submit" variant="danger" class="ms-1" @click="rejectLeave"
          >{{ $t('menuitems.attendance.reject') }}</b-button
        >
      </div>
      </div>
    </b-modal>
  </Layout>
</template>
<style scoped>
table {
        table-layout:fixed;
    }
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
tbody {
    display:block;
    height: calc(100vh - 430px);
    overflow:auto;
}
thead, tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
}
</style>